import palette from './palette';
import { TypographyOptions } from '@material-ui/core/styles/createTypography';

const typographyThemes: TypographyOptions = {
  h1: {
    color: palette.text!.primary,
    fontWeight: 500,
    fontSize: '35px',
    letterSpacing: '-0.24px',
    lineHeight: '40px',
    fontFamily: 'Hiragino Sans',
  },
  h2: {
    color: palette.text!.primary,
    fontWeight: 500,
    fontSize: '29px',
    letterSpacing: '-0.24px',
    lineHeight: '32px',
    fontFamily: 'Hiragino Sans',
  },
  h3: {
    color: palette.text!.primary,
    fontWeight: 500,
    fontSize: '24px',
    letterSpacing: '-0.06px',
    lineHeight: '28px',
    fontFamily: 'Hiragino Sans',
  },
  h4: {
    color: palette.text!.primary,
    fontWeight: 500,
    fontSize: '20px',
    letterSpacing: '-0.06px',
    lineHeight: '24px',
    fontFamily: 'Hiragino Sans',
  },
  h5: {
    color: palette.text!.primary,
    fontWeight: 500,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
    fontFamily: 'Hiragino Sans',
  },
  h6: {
    color: palette.text!.primary,
    fontWeight: 500,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
    fontFamily: 'Hiragino Sans',
  },
  subtitle1: {
    color: palette.text!.primary,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '25px',
    fontFamily: 'Hiragino Sans',
  },
  subtitle2: {
    color: palette.text!.secondary,
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '21px',
    fontFamily: 'Hiragino Sans',
  },
  body1: {
    color: palette.text!.primary,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '21px',
    fontFamily: 'Hiragino Sans',
  },
  body2: {
    color: palette.text!.secondary,
    fontSize: '12px',
    letterSpacing: '-0.04px',
    lineHeight: '18px',
    fontFamily: 'Hiragino Sans',
  },
  button: {
    color: palette.text!.primary,
    fontSize: '14px',
    fontFamily: 'Hiragino Sans',
  },
  caption: {
    color: palette.text!.secondary,
    fontSize: '11px',
    letterSpacing: '0.33px',
    lineHeight: '13px',
    fontFamily: 'Hiragino Sans',
  },
  overline: {
    color: palette.text!.secondary,
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase',
    fontFamily: 'Hiragino Sans',
  },
};

export default typographyThemes;
